import H5PSingleView from "@features/tools/view/h5p-single-view";

const H5PSingle = () => {
  return <H5PSingleView />;
};

export default H5PSingle;
